var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { I18nService } from '@app/core';
import { UtilService } from './util.service';
import { CryptographyService } from '@app/cryptography.service';
import { environment } from '@env/environment';
var ConfigType;
(function (ConfigType) {
    ConfigType[ConfigType["ApiUrl"] = 1] = "ApiUrl";
    ConfigType[ConfigType["CustomApiUrl"] = 2] = "CustomApiUrl";
    ConfigType[ConfigType["LogInUrl"] = 3] = "LogInUrl";
    ConfigType[ConfigType["PortalApiUrl"] = 4] = "PortalApiUrl";
    ConfigType[ConfigType["PortalLoginUrl"] = 5] = "PortalLoginUrl";
    ConfigType[ConfigType["PortalUrl"] = 6] = "PortalUrl";
})(ConfigType || (ConfigType = {}));
var ApiService = /** @class */ (function () {
    function ApiService(http, route, i18nService, util, crypto) {
        this.http = http;
        this.route = route;
        this.i18nService = i18nService;
        this.util = util;
        this.crypto = crypto;
    }
    ApiService.prototype.get = function (system, action, queryParam) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj = {
                            m: this.crypto.encrypt("GET", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam), aesKey),
                            s: aesPublic
                        };
                        url = "";
                        if (environment.apiPort == "") {
                            url = this.util.baseUrl() + environment.apiPath;
                        }
                        else {
                            url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/Core/PostApi";
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                    var res;
                                    return __generator(this, function (_a) {
                                        if (data["_body"] != null && data["_body"] != "") {
                                            res = data.json();
                                            res = this.crypto.decryptDictValue(res, aesKey);
                                            resolve(res);
                                        }
                                        else {
                                            resolve(data);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getMasterAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url;
            return __generator(this, function (_a) {
                url = "";
                if (environment.apiPort == "") {
                    url = this.util.baseUrl() + environment.apiPath;
                }
                else {
                    url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                }
                //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                url += "/api/master/address";
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get(url).toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res);
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            console.error("get address failed.");
                        });
                    })];
            });
        });
    };
    ApiService.prototype.post = function (system, action, dataObj, mode, branchID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj2, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataObj["dpa_callby"] = '3';
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj2 = {
                            m: this.crypto.encrypt("POST", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
                            s: aesPublic,
                            req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
                        };
                        url = "";
                        if (environment.apiPort == "") {
                            url = this.util.baseUrl() + environment.apiPath;
                        }
                        else {
                            url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/Core/PostApi";
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj2).toPromise().then(function (data) {
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res, aesKey);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getPortal = function (system, action, queryParam) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj = {
                            route: this.crypto.encrypt("/api/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam), aesKey),
                            s: aesPublic
                        };
                        url = "";
                        if (environment.apiPort == "") {
                            url = this.util.baseUrl() + environment.apiPath;
                        }
                        else {
                            url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
                        url += "/api/" + system + "/" + action; //+ param
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                    var res;
                                    return __generator(this, function (_a) {
                                        if (data["_body"] != null && data["_body"] != "") {
                                            res = data.json();
                                            res = this.crypto.decryptDictValue(res, aesKey);
                                            resolve(res);
                                        }
                                        else {
                                            resolve(data);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.postPortal = function (system, action, dataObj) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, pbk, aesKey, aesPublic, reqObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "";
                        if (environment.apiPort == "") {
                            url = this.util.baseUrl() + environment.apiPath;
                        }
                        else {
                            url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/" + system + "/" + action;
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj = __assign({}, dataObj);
                        reqObj = this.crypto.encryptDictValue(reqObj, aesKey);
                        reqObj["s"] = aesPublic;
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj).toPromise().then(function (data) {
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res, aesKey);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    _this.util.ShowWaiting(false);
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.put = function (system, action, dataObj, mode, branchID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj2, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataObj["dpa_callby"] = '3';
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj2 = {
                            m: this.crypto.encrypt("PUT", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
                            s: aesPublic,
                            req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
                        };
                        url = "";
                        if (environment.apiPort == "") {
                            url = this.util.baseUrl() + environment.apiPath;
                        }
                        else {
                            url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/Core/PostApi";
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj2).toPromise().then(function (data) {
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res, aesKey);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.delete = function (system, action) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, url, header, _b, _c, _d, _e, options;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!(this.API_URL == undefined || this.API_URL == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getConfig(ConfigType.ApiUrl)];
                    case 1:
                        _a.API_URL = _f.sent();
                        _f.label = 2;
                    case 2:
                        if (this.ipClient == undefined || this.ipClient == null) {
                            this.ipClient = sessionStorage.getItem("clientIP");
                        }
                        url = this.API_URL + '/' + system + '/' + action;
                        _b = Headers.bind;
                        _c = {
                            'Content-Type': 'application/json'
                        };
                        _d = 'Authorization';
                        _e = 'Bearer ';
                        return [4 /*yield*/, this.getToken()];
                    case 3:
                        header = new (_b.apply(Headers, [void 0, (_c[_d] = _e + (_f.sent()),
                                _c)]))();
                        options = new RequestOptions({ headers: header });
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.delete(url, options).toPromise().then(function (data) {
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]));
                                        err["_body"] = JSON.stringify(tmp);
                                    }
                                    if (err.statusText == 'OK') {
                                        resolve(err);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getConfig = function (Type) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var configData;
            return __generator(this, function (_a) {
                configData = '';
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            if (Type == ConfigType.ApiUrl)
                                resolve(_this.crypto.decrypt(res.ApiUrl));
                            else if (Type == ConfigType.CustomApiUrl)
                                resolve(_this.crypto.decrypt(res.CustomApiUrl));
                            else if (Type == ConfigType.PortalApiUrl)
                                resolve(_this.crypto.decrypt(res.PortalApiUrl));
                            else if (Type == ConfigType.PortalLoginUrl)
                                resolve(_this.crypto.decrypt(res.PortalLoginUrl));
                            else if (Type == ConfigType.PortalUrl)
                                resolve(_this.crypto.decrypt(res.PortalUrl));
                            else
                                resolve(_this.crypto.decrypt(res.LoginUrl));
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            // sessionStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
                            // this.route.navigate(['/error']);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.GetPortalLoginUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getConfig(ConfigType.PortalLoginUrl)];
            });
        });
    };
    ApiService.prototype.upload = function (system, action, dataObj) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, url;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.API_URL == undefined || this.API_URL == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getConfig(ConfigType.ApiUrl)];
                    case 1:
                        _a.API_URL = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.ipClient == undefined || this.ipClient == null) {
                            this.ipClient = sessionStorage.getItem("clientIP");
                        }
                        url = 'http://localhost:53675/api/upload/UploadFile';
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, dataObj).toPromise().then(function (data) {
                                    var res = data.json();
                                    resolve(res);
                                }).catch(function (err) {
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getIP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, url;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.API_URL == undefined || this.API_URL == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getConfig(ConfigType.ApiUrl)];
                    case 1:
                        _a.API_URL = _b.sent();
                        _b.label = 2;
                    case 2:
                        url = this.API_URL + "/ip/GetIp";
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.get(url).toPromise().then(function (data) {
                                    var res = data.json();
                                    resolve(res);
                                }).catch(function (err) {
                                    _this.util.ShowWaiting(false);
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.CheckSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var result, _a, url, header, _b, _c, _d, _e, options, dataObj, datapost, datares, url_login;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        console.log("CheckSession");
                        result = false;
                        if (!(this.API_URL == undefined || this.API_URL == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getConfig(ConfigType.ApiUrl)];
                    case 1:
                        _a.API_URL = _f.sent();
                        _f.label = 2;
                    case 2:
                        url = this.API_URL + "/account/GetUserSessionCurrent";
                        _b = Headers.bind;
                        _c = {
                            'Content-Type': 'application/json'
                        };
                        _d = 'Authorization';
                        _e = 'Bearer ';
                        return [4 /*yield*/, this.getToken()];
                    case 3:
                        header = new (_b.apply(Headers, [void 0, (_c[_d] = _e + (_f.sent()),
                                _c)]))();
                        options = new RequestOptions({ headers: header });
                        dataObj = {};
                        dataObj["ip_address"] = this.util.GetCurrIP();
                        dataObj["member_no"] = this.util.GetUserID();
                        datapost = {};
                        datapost["user"] = this.util.GetUserID();
                        datapost["ip"] = this.util.GetClientIP();
                        datapost["lang"] = this.i18nService.language;
                        datapost["requestData"] = dataObj;
                        console.log(url);
                        return [4 /*yield*/, new Promise(function (resolve) {
                                _this.http.post(url, datapost, options).toPromise().then(function (data) {
                                    var res = data.json();
                                    resolve(res);
                                }).catch(function (err) {
                                    _this.util.ShowWaiting(false);
                                    throw err;
                                });
                            })];
                    case 4:
                        datares = _f.sent();
                        if (datares != null) {
                            if (datares.isSuccess) {
                                if (datares.responseData) {
                                    if (datares.responseData.length > 0) {
                                        result = true;
                                    }
                                }
                            }
                        }
                        if (!!result) return [3 /*break*/, 6];
                        sessionStorage.setItem("clientIP", null);
                        sessionStorage.setItem("clientUser", null);
                        sessionStorage.setItem("member_obj", null);
                        return [4 /*yield*/, this.getConfig(ConfigType.LogInUrl)];
                    case 5:
                        url_login = _f.sent();
                        window.location.href = url_login;
                        _f.label = 6;
                    case 6: return [2 /*return*/, result];
                }
            });
        });
    };
    ApiService.prototype.postnotauthen = function (system, action, dataObj, mode, branchID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj2, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if (this.API_URL == undefined || this.API_URL == null) {
                        //   this.API_URL = await this.getConfig(ConfigType.ApiUrl);
                        // }
                        // if (this.ipClient == undefined || this.ipClient == null) {
                        //   this.ipClient = sessionStorage.getItem("clientIP");
                        // }
                        // const url = this.API_URL + '/' + system + '/' + action;
                        // const header = new Headers({
                        //   'Content-Type': 'application/json',
                        //   'Authorization': 'Bearer ' + await this.getToken()
                        // });
                        // const options = new RequestOptions({ headers: header });
                        // // var datahead = {};
                        // // datahead["client_ip"] = this.ipClient;
                        // // datahead["lang"] = this.i18nService.language;
                        // dataObj = this.crypto.encryptDictValue(dataObj)
                        // return new Promise(resolve => {
                        //   this.http.post(url, dataObj, options).toPromise().then((data) => {
                        //     let res = data.json();
                        //       res = this.crypto.decryptDictValue(res)
                        //       resolve(res);
                        //   }).catch((err) => {
                        //     this.util.ShowWaiting(false);
                        //     if (action == "agentbankLogin") 
                        //       return resolve(this.crypto.decryptDictValue(JSON.parse(err["_body"])));
                        //     this.util.ErrorDialog('System Error : ' + err);
                        //   });
                        // });
                        // if (this.API_URL == undefined || this.API_URL == null) {
                        //   this.API_URL = await this.getConfig();
                        // }
                        // if (this.ipClient == undefined || this.ipClient == null) {
                        //   this.ipClient = localStorage.getItem("clientIP");
                        // }
                        dataObj["dpa_callby"] = '3';
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj2 = {
                            m: this.crypto.encrypt("POST", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
                            s: aesPublic,
                            req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
                        };
                        url = "";
                        if (environment.apiPort == "") {
                            url = this.util.baseUrl() + environment.apiPath;
                        }
                        else {
                            url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/Core/PostApi";
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj2).toPromise().then(function (data) {
                                    var res = data.json();
                                    res = _this.crypto.decryptDictValue(res, aesKey);
                                    resolve(res);
                                }).catch(function (err) {
                                    _this.util.ShowWaiting(false);
                                    if (action == "agentbankLogin")
                                        return resolve(_this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey));
                                    _this.util.ErrorDialog('System Error : ' + err);
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getTokenConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res);
                        }).catch(function (err) {
                            return null;
                        });
                    })];
            });
        });
    };
    ApiService.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var config, url, req, header, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTokenConfig()];
                    case 1:
                        config = _a.sent();
                        url = this.crypto.decrypt(config.getTokenUrl);
                        req = {
                            "username": config.getTokenUser,
                            "password": config.getTokenPassword
                        };
                        header = new Headers({ 'Content-Type': 'application/json' });
                        options = new RequestOptions({ headers: header });
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, req, options).toPromise().then(function (data) {
                                    var res = data.json();
                                    resolve(res.AccessToken);
                                }).catch(function (err) {
                                    if (err.statusText == 'OK') {
                                        resolve(err);
                                    }
                                    else {
                                        _this.util.ShowWaiting(false);
                                        resolve(null);
                                        //this.util.ErrorDialog('System Error : ' + err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url;
            return __generator(this, function (_a) {
                url = "";
                if (environment.apiPort == "") {
                    url = this.util.baseUrl() + environment.apiPath;
                }
                else {
                    url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                }
                //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
                url += "/api/" + "Key" + "/" + "GetKey";
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get(url).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                res = data.json();
                                resolve(res);
                                return [2 /*return*/];
                            });
                        }); }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.keyFromCk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pbk, getKeyRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pbk = JSON.parse(localStorage.getItem("pbk"));
                        if (!(pbk != null && pbk != "")) return [3 /*break*/, 1];
                        return [2 /*return*/, pbk];
                    case 1: return [4 /*yield*/, this.getKey()];
                    case 2:
                        getKeyRes = _a.sent();
                        pbk = getKeyRes;
                        localStorage.setItem("pbk", JSON.stringify(pbk));
                        return [2 /*return*/, getKeyRes];
                }
            });
        });
    };
    return ApiService;
}());
export { ApiService };



// WEBPACK FOOTER //
// ./src/app/utility/api.service.ts.pre-build-optimizer.js